// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1lZer","selected":"Chip_selected___xq5v"};